import { render, staticRenderFns } from "./dingzhiForm.vue?vue&type=template&id=39eb3325&scoped=true&"
import script from "./dingzhiForm.vue?vue&type=script&lang=js&"
export * from "./dingzhiForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39eb3325",
  null
  
)

export default component.exports